var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExclamationNegative = function SvgExclamationNegative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
      version: 1
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 3.4c2.7-4.5 9.2-4.5 12 0l28 46c2.8 4.7-0.5 10.6-6 10.6l-56 0c-5.5 0-8.8-6-6-10.6l28-46Zm6 14.7c1.9 0 3.5 1.6 3.5 3.5l0 14c0 1.9-1.6 3.5-3.5 3.5 -1.9 0-3.5-1.6-3.5-3.5l0-14c0-1.9 1.6-3.5 3.5-3.5Zm0 36.2c2.6 0 4.7-2.1 4.7-4.7 0-2.6-2.1-4.7-4.7-4.7 -2.6 0-4.7 2.1-4.7 4.7 0 2.6 2.1 4.7 4.7 4.7Z"
  })));
};
export default SvgExclamationNegative;